@if(selectedProjectId() !== null){
@if (wizardInitializing()) {
<div
  class="d-flex flex-column align-items-center justify-content-center py-5 my-5"
>
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{ "general.loading" | translate }}</span>
  </div>
  <p class="text-body-secondary mt-3 mb-0">
    {{ "general.loading" | translate }}
  </p>
</div>
} @else {
<div class="row">
  <div class="col-6 my-2">
    <label class="project-name">{{ projectName() }}</label>
  </div>
  <div class="col-6 my-2 d-flex justify-content-end actions">
    <button
      class="btn btn-falcon-default btn-sm me-3"
      type="button"
      [disabled]="!canEditWizard()"
      (click)="onSaveDraftClick()"
    >
      <span class="fas fa-save me-2" data-fa-transform="shrink-3"></span
      >{{ "projectWizard.saveDraft" | translate }}
    </button>
    <div class="d-flex flex-column align-items-end gap-1">
      <button
        class="btn btn-primary btn-sm"
        type="button"
        [disabled]="
          submittingForVerification() || !canRunUserPrimaryAction()
        "
        [attr.title]="
          userPrimaryTooltipKey()
            ? (userPrimaryTooltipKey()! | translate)
            : null
        "
        (click)="onUserPrimaryAction()"
      >
        <span class="fab fa-telegram-plane btn-icon" data-fa-transform="grow-5">
        </span>
        {{ userPrimaryButtonLabelKey() | translate }}
      </button>
    </div>
  </div>
</div>
<ng-template #projectWizardNextPrimaryTpl>
  <span class="fab fa-telegram-plane btn-icon" data-fa-transform="grow-5"></span>
  {{ userPrimaryButtonLabelKey() | translate }}
</ng-template>
<app-wizard
  [prevButtonEnabled]="true"
  [nextButtonEnabled]="wizardNextFooterEnabled()"
  [prevButtonText]="prevButtonText()"
  [nextButtonText]="nextStepLabelKey"
  [prevButtonHasChevron]="prevButtonHasChevron()"
  [nextButtonHasChevron]="nextButtonHasChevron()"
  [nextButtonContentTpl]="
    isOnLastWizardStep() ? projectWizardNextPrimaryTpl : null
  "
  [nextButtonTitleKey]="sectionJFooterTooltipKey()"
  [items]="stepsStore.actualSteps()"
  (stepSelection)="onStepSelection($event)"
  (nextButtonClicked)="onNextButtonClick()"
  (prevButtonClicked)="onPreviousButtonClick()"
>
  <div wizardNavExtra>
    <app-project-wizard-contact-help [contactUserId]="contactUserId()" />
  </div>
  <div [class.project-wizard-readonly-content]="!canEditWizard()">
  @switch (stepsStore.stepIndex()) { @case (0) {
  <app-wizard-step
    stepId="form-wizard-progress-tab0"
    [stepNumber]="0"
    [isActive]="stepsStore.stepIndex() == 0"
  >
    <app-base-data-step [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (1) {
  <app-wizard-step
    stepId="form-wizard-progress-tab1"
    [stepNumber]="1"
    [isActive]="stepsStore.stepIndex() == 1"
  >
    <app-section-a [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (2) {
  <app-wizard-step
    stepId="form-wizard-progress-tab2"
    [stepNumber]="2"
    [isActive]="stepsStore.stepIndex() == 2"
  >
    <app-section-b [projectId]="selectedProjectId()!" />
  </app-wizard-step>

  } @case (3) {
  <app-wizard-step
    stepId="form-wizard-progress-tab3"
    [stepNumber]="3"
    [isActive]="stepsStore.stepIndex() == 3"
  >
    <app-section-c [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (4) {
  <app-wizard-step
    stepId="form-wizard-progress-tab4"
    [stepNumber]="4"
    [isActive]="stepsStore.stepIndex() == 4"
  >
    <app-section-d
      [projectId]="selectedProjectId()!"
      [stepDisabled]="stepsStore.actualSteps()[4]?.stepType === StepType.disabled"
    />
  </app-wizard-step>
  } @case (5) {

  <app-wizard-step
    stepId="form-wizard-progress-tab5"
    [stepNumber]="5"
    [isActive]="stepsStore.stepIndex() == 5"
  >
    <app-section-e
      [projectId]="selectedProjectId()!"
      [stepDisabled]="stepsStore.actualSteps()[5]?.stepType === StepType.disabled"
    />
  </app-wizard-step>
  } @case (6) {
  <app-wizard-step
    stepId="form-wizard-progress-tab6"
    [stepNumber]="6"
    [isActive]="stepsStore.stepIndex() == 6"
  >
    <app-section-f [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (7) {
  <app-wizard-step
    stepId="form-wizard-progress-tab7"
    [stepNumber]="7"
    [isActive]="stepsStore.stepIndex() == 7"
  >
    <app-section-g [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (8) {
  <app-wizard-step
    stepId="form-wizard-progress-tab8"
    [stepNumber]="8"
    [isActive]="stepsStore.stepIndex() == 8"
  >
    <app-section-h [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (9) {
  <app-wizard-step
    stepId="form-wizard-progress-tab9"
    [stepNumber]="9"
    [isActive]="stepsStore.stepIndex() == 9"
  >
    <app-section-i [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (10) {
  <app-wizard-step
    stepId="form-wizard-progress-tab10"
    [stepNumber]="10"
    [isActive]="stepsStore.stepIndex() == 10"
  >
    <app-section-j [projectId]="selectedProjectId()!" />
  </app-wizard-step>

  } }
  </div>
</app-wizard>
}
}
